module.exports = __webpack_public_path__ + "img/more.4dd25544.svg";